module.exports = __webpack_public_path__ + "static/img/full.df4b432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/full.png
// module id = 4HMN
// module chunks = 24